import script from "./ProductsConfiguration.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductsConfiguration.vue?vue&type=script&setup=true&lang=js"

import "./ProductsConfiguration.vue?vue&type=style&index=0&id=836413f6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-836413f6"]])

export default __exports__